var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.977 5.22372C29.8494 3.77364 28.0891 3.12799 27.0587 4.15854L25.5869 5.63036C25.2578 5.95942 24.7175 5.96481 24.3825 5.64231C24.0348 5.30768 24.0529 4.73118 24.3946 4.38946L25.8422 2.94184C26.8716 1.91241 26.2287 0.15143 24.7774 0.0236373C20.833 -0.323179 17.7043 3.3452 18.7504 7.23512L0.832214 25.1533C-0.277317 26.2628 -0.277493 28.0588 0.832214 29.1685C1.93923 30.2754 3.74034 30.2755 4.84735 29.1685L22.7609 11.2548C26.6044 12.2999 30.3275 9.20411 29.977 5.22372Z",
    fill: "#16DBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87498 6.88238C1.91699 6.96523 1.97183 7.04093 2.03752 7.10662L4.58096 9.65C4.9242 9.99324 5.48066 9.99318 5.82385 9.65L7.1173 8.35654L9.5875 10.8267L6.94662 13.4676C6.2623 14.1531 6.26289 15.2681 6.94721 15.953L7.22435 16.2301L16.238 7.21706L15.9609 6.93992C15.273 6.25326 14.1631 6.25226 13.4743 6.93992L10.8304 9.58378L8.36019 7.11359L9.65365 5.82013C9.99689 5.47695 9.99689 4.92042 9.65365 4.57724L7.11027 2.0338C7.04389 1.96736 6.96725 1.91205 6.88334 1.86992L3.63244 0.236791C3.29377 0.0666351 2.88443 0.13267 2.61642 0.400678L0.395135 2.62191C0.126424 2.89062 0.060858 3.30154 0.232596 3.64056L1.87498 6.88238Z",
    fill: "#16DBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3823 15.1198L15.126 21.3761L22.311 28.5629C24.0394 30.2913 26.8378 30.2918 28.5667 28.5629C30.2917 26.838 30.2917 24.0315 28.5667 22.3071L21.3823 15.1198ZM26.5307 26.5251C26.1897 26.8673 25.6318 26.8689 25.288 26.5251L20.2996 21.5366C19.9562 21.1933 19.9562 20.6367 20.2996 20.2939C20.6429 19.9506 21.1995 19.9506 21.5423 20.2939L26.5307 25.2824C26.874 25.6257 26.874 26.1817 26.5307 26.5251Z",
    fill: "#16DBCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.9c1883f890ddf617a67aebac445ff5a6.svg";
export { ForwardRef as ReactComponent };